import { render, staticRenderFns } from "./SaleHistoryList.vue?vue&type=template&id=f54f0fb2"
import script from "./SaleHistoryList.vue?vue&type=script&lang=js"
export * from "./SaleHistoryList.vue?vue&type=script&lang=js"
import style0 from "./SaleHistoryList.vue?vue&type=style&index=0&id=f54f0fb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports